export enum PdfFieldType {
  Text = 'text',
  Checkbox = 'checkbox',
  Signature = 'signature',
  Stamp = 'stamp',
  Empty = 'empty',
  Unknown = 'unknown',
}

export type Mappings = Record<string, string | boolean>;
